<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon *ngIf="!isMoreInfo" nbPrefix icon="search-outline"></nb-icon>
          <nb-icon *ngIf="isMoreInfo" nbPrefix icon="person-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="{{
              isMoreInfo
                ? ('common.inputName' | translate)
                : ('common.strSearch' | translate)
            }}"
            [(ngModel)]="person.fullName"
            (keydown.enter)="inputMobile()"
            #title
          />
        </nb-form-field>

        <button
          nbButton
          outline
          shape="round"
          status="info"
          size="small"
          (click)="inputMore()"
        >
          <nb-icon
            [icon]="
              isMoreInfo
                ? 'arrow-ios-upward-outline'
                : 'arrow-ios-downward-outline'
            "
          ></nb-icon>
        </button>

        <button
          *ngIf="!isMoreInfo"
          nbButton
          outline
          shape="semi-round"
          status="primary"
          size="small"
          (click)="onNew()"
          [disabled]="loading"
          [class.btn-pulse]="loading"
        >
          <span>{{ "buttons.create" | translate }}</span>
        </button>

        <button
          *ngIf="isMoreInfo"
          nbButton
          hero
          status="info"
          size="small"
          (click)="create()"
          [disabled]="
            submitted || !person.fullName || person.fullName.length === 0
          "
          [class.btn-pulse]="submitted"
        >
          <nb-icon nbPrefix icon="save-outline"></nb-icon>
          {{ "buttons.save" | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="isMoreInfo" class="row">
      <div class="col-12 form-inline">
        <nb-form-field>
          <nb-icon nbPrefix icon="phone-call-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="Nhập số điện thoại"
            [(ngModel)]="person.mobile"
            (keydown.enter)="create()"
            #mobile
          />
        </nb-form-field>

        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="globe-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="Nhập địa chỉ"
            [(ngModel)]="person.address"
            (keydown.enter)="create()"
            #address
          />
        </nb-form-field>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div
        *ngFor="let item of persons | filter: person.fullName; let i = index"
        class="col-md-12"
      >
        <ngx-view-person
          [person]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-person>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>
</nb-card>
